export default "__VITE_ASSET__c2debbdd__"